import { message, Input, Select, Col, Row } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    SelectItem,
    cuentaMask,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    TourItem,
    TextAreaItem
} from "../../../../Components/Items";
import { PlusOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;

class AgregarFamiliaConAsistente extends Component {
    formRef = React.createRef();
    refCol1 = React.createRef();
    refCol2 = React.createRef();
    refGen = React.createRef();
    state = {
        loading: false,
        objetoCuentaContable: null,
        todasCuentaContable: null,
        modalAgregarCuentaContable: false,
        openTour: false, // Cambia a false si no quieres que el tour se muestre al inicio
    };

    async componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            await this.consultarTodo();
            await this.buscarCuentasContables();
            if (this.props.familiasLength === 0) {
                this.setState({ openTour: true }); // Abre el tour si no hay familias
            }
        }
    }
    cerrarAgregarFamiliaConAsistente(codigo) {
        this.props.cerrarAgregarFamiliaConAsistente(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "cuentascontables/selectCuentasContablesSinNivel5",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasCuentaContable: res.data,
                        objetoCuentaContable: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {cuentaMask(
                                        value.nivel1 +
                                        value.nivel2 +
                                        value.nivel3 +
                                        value.nivel4 +
                                        value.nivel5
                                    ) +
                                        " - " +
                                        value.descripcion}
                                </Option>
                            );
                        }),
                    });
                }
            });
        this.setState({ loading: false });
    }
    async buscarCuentasContables() {
        let buscarCuentaInventario = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "01" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
        let buscarCuentaCosto = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "501" && todasCuentas.nivel2 === "01" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
        let buscarCuentaTransito = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "05" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
        let buscarCuentaAjusteInventario = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "501" && todasCuentas.nivel2 === "08" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
        let buscarCuentaIngresoContado = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "401" && todasCuentas.nivel2 === "02" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
        let buscarCuentaIngresoCredito = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "401" && todasCuentas.nivel2 === "03" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
        let buscarCuentaTerceros = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "06" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));

        if (!buscarCuentaInventario || !buscarCuentaCosto || !buscarCuentaTransito || !buscarCuentaAjusteInventario || !buscarCuentaIngresoContado || !buscarCuentaIngresoCredito || !buscarCuentaTerceros) {
            message.warning("No se encontraron todas las cuentas contables necesarias para el asistente. Por favor, asegúrate de tener las cuentas contables configuradas correctamente.");
        }

        this.formRef.current.setFieldsValue({
            cuentaInventarioId: buscarCuentaInventario ? buscarCuentaInventario._id : undefined,
            cuentaCostoGastoId: buscarCuentaCosto ? buscarCuentaCosto._id : undefined,
            cuentaTransitoId: buscarCuentaTransito ? buscarCuentaTransito._id : undefined,
            cuentaAjusteInventarioId: buscarCuentaAjusteInventario ? buscarCuentaAjusteInventario._id : undefined,
            cuentaIngresoContadoId: buscarCuentaIngresoContado ? buscarCuentaIngresoContado._id : undefined,
            cuentaIngresoCreditoId: buscarCuentaIngresoCredito ? buscarCuentaIngresoCredito._id : undefined,
            cuentaTercerosId: buscarCuentaTerceros ? buscarCuentaTerceros._id : undefined,
        });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "familias/agregarFamiliaConAsistente",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una familia");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarFamiliaConAsistente(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede registrar la familia");
                } else {
                    message.error("Hubo un error y la familia no se registro");
                }
            });
    }
    abrirAgregarCuentaContable() {
        this.setState({ modalAgregarCuentaContable: true });
    }
    cerrarAgregarCuentaContable(codigo) {
        this.setState({ modalAgregarCuentaContable: false });
        this.consultarTodo();
    }

    onChangeSwitches() {
        const inventariable = this.formRef.current.getFieldValue("inventariable");
        const transito = this.formRef.current.getFieldValue("transito");
        const costo = this.formRef.current.getFieldValue("costo");
        const ingresosSeparados = this.formRef.current.getFieldValue("ingresosSeparados");
        const cuentaTercerosGenerar = this.formRef.current.getFieldValue("cuentaTercerosGenerar");
        const gastoNoDeducible = this.formRef.current.getFieldValue("gastoNoDeducible");
        if (!gastoNoDeducible) {

            let cuentaInventario
            let cuentaCosto
            let cuentaTransito
            let cuentaAjusteInventario
            let cuentaIngresoContado
            let cuentaIngresoCredito
            let cuentaTerceros;

            if (costo) {
                cuentaCosto = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "501" && todasCuentas.nivel2 === "01" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
            } else {
                cuentaCosto = undefined;
            }

            if (inventariable) {
                cuentaInventario = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "01" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
                cuentaAjusteInventario = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "501" && todasCuentas.nivel2 === "08" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
            } else {
                cuentaInventario = cuentaCosto
                cuentaAjusteInventario = cuentaCosto
            }

            if (transito) {
                cuentaTransito = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "05" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
            } else {
                cuentaTransito = cuentaInventario
            }

            if (ingresosSeparados) {
                cuentaIngresoContado = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "401" && todasCuentas.nivel2 === "02" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
                cuentaIngresoCredito = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "401" && todasCuentas.nivel2 === "03" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
            } else {
                cuentaIngresoContado = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "401" && todasCuentas.nivel2 === "01" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
                cuentaIngresoCredito = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "401" && todasCuentas.nivel2 === "01" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
            }

            if (cuentaTercerosGenerar) {
                cuentaTerceros = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "06" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));
            } else {
                cuentaTerceros = cuentaInventario;
            }

            this.formRef.current.setFieldsValue({
                cuentaInventarioId: cuentaInventario ? cuentaInventario._id : undefined,
                cuentaCostoGastoId: cuentaCosto ? cuentaCosto._id : undefined,
                cuentaTransitoId: cuentaTransito ? cuentaTransito._id : undefined,
                cuentaAjusteInventarioId: cuentaAjusteInventario ? cuentaAjusteInventario._id : undefined,
                cuentaIngresoContadoId: cuentaIngresoContado ? cuentaIngresoContado._id : undefined,
                cuentaIngresoCreditoId: cuentaIngresoCredito ? cuentaIngresoCredito._id : undefined,
                cuentaTercerosId: cuentaTerceros ? cuentaTerceros._id : undefined,
            });

        } else {
            
            if (transito) {
                const cuentaTransito = this.state.todasCuentaContable.find(todasCuentas => todasCuentas.nivel1 === "115" && todasCuentas.nivel2 === "05" && (todasCuentas.nivel3 === "" || !todasCuentas.nivel3));

                this.formRef.current.setFieldsValue({
                    cuentaTransitoId: cuentaTransito ? cuentaTransito._id : undefined,
                });
            } else {
                let cuentaTransitoId = this.formRef.current.getFieldValue("cuentaGastoNoDeducibleId");
                this.formRef.current.setFieldsValue({
                    cuentaTransitoId: cuentaTransitoId,
                });
            }

        }
    }

    render() {

        const steps = [
            {
                title: 'Asistente de Creación de Familias',
                description: 'Hola soy el asistente de creación de familias, y estoy aquí para ayudarte a crear las familias de manera más rápida y sencilla. Solo necesitarás ingresar las cuentas contables padre de un lado, y yo me encargaré de crear la cuenta contable hija con el nombre de la familia, lo que te ahorrará tiempo. Además, ya seleccioné algunas cuentas que la contabilidad utiliza normalmente. Si deseas cambiarlas, puedes hacerlo fácilmente.',
                placement: 'top',
                target: null,
            },
            {
                title: 'Datos Generales de la Familia',
                description: 'Estos son los datos generales de la familia. El nombre que ingreses aquí será el que utilizaré para guardar las cuentas contables hijas. Además, si se trata de un gasto no deducible, tendrás la opción de activarlo aquí mismo para ajustar las cuentas contables de acuerdo con esa selección.',
                target: () => this.refGen.current,
            },
            {
                title: 'Cuentas Contables Padre',
                description: 'Estas serán las cuentas contables padre que usaré para crear las cuentas de la familia. Yo me encargaré de crear automáticamente las cuentas hijas relacionadas con ellas. Así, podrás ahorrar tiempo en el proceso de creación.',
                target: () => this.refCol1.current,
            },
            {
                title: 'Tipo de Familia',
                description: 'Estos switches te ayudarán a definir qué tipo de familia deseas. Según tu elección, yo modificaré las cuentas contables para adaptarlas a la mejor opción según tus necesidades. Solo selecciona las opciones que correspondan y el sistema hará el resto.',
                target: () => this.refCol2.current,
            }
        ];

        return (
            <>
                <ModalItem
                    title={
                        <span>
                            Agregar Familia con Asistente
                            <ButtonItem
                                type="primary"
                                style={{ marginLeft: '10px' }}
                                disabled={this.state.loading}
                                onClick={() => this.setState({ openTour: true })} // Abre el tour al hacer clic en el botón
                            >
                                Tour
                            </ButtonItem>
                        </span>
                    }
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarFamiliaConAsistente.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarFamiliaConAsistente"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Row ref={this.refGen}>
                            <Col span={24}>
                                <FormItem
                                    label="Gasto No Deducible"
                                    name="gastoNoDeducible"
                                    margin
                                    initialValue={false}
                                    tooltip={{
                                        title:
                                            "Al activarse hara que todos lo insumos registrados con esta familia se vayan a una cuenta de no gastos no deducibles al igual que sus impuestos, exeptuando las retenciones correspondientes. Solamente se podra aplicar a insumos de compra y no inventariables.",
                                    }}
                                    valuePropName="checked"
                                >
                                    <SwitchItem />
                                </FormItem>
                                <FormItem
                                    name="nombre"
                                    label="Nombre"
                                    required
                                    max={100}
                                    margin
                                    pattern
                                >
                                    <InputItem placeholder="Nombre" />
                                </FormItem>
                                <FormItem name="descripcion" label="Descripción" margin pattern>
                                    <TextAreaItem placeholder="Descripción" />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "20px" }}>
                            <Col span={18} ref={this.refCol1}>
                                <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                        const gastoNoDeducible = getFieldValue("gastoNoDeducible");
                                        if (gastoNoDeducible) {
                                            return (
                                                <>
                                                    <FormItem label="Cuenta Gasto" margin>
                                                        <Input.Group compact>
                                                            <FormItem
                                                                name="cuentaGastoNoDeducibleId"
                                                                required
                                                                noStyle
                                                            >
                                                                <SelectItem placeholder="Cuenta Gasto" width="80%">
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Transito" margin>
                                                        <Input.Group compact>
                                                            <FormItem name="cuentaTransitoId" required noStyle>
                                                                <SelectItem
                                                                    placeholder="Cuenta Transito"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                </>
                                            );
                                        } else {
                                            return (
                                                <>
                                                    <FormItem label="Cuenta Inventario" margin>
                                                        <Input.Group compact>
                                                            <FormItem name="cuentaInventarioId" required noStyle>
                                                                <SelectItem
                                                                    placeholder="Cuenta Inventario"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Costo/Gasto" margin>
                                                        <Input.Group compact>
                                                            <FormItem name="cuentaCostoGastoId" required noStyle>
                                                                <SelectItem
                                                                    placeholder="Cuenta Costo/Gasto"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Transito" margin>
                                                        <Input.Group compact>
                                                            <FormItem name="cuentaTransitoId" required noStyle>
                                                                <SelectItem
                                                                    placeholder="Cuenta Transito"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Ajuste Inventario" margin>
                                                        <Input.Group compact>
                                                            <FormItem
                                                                name="cuentaAjusteInventarioId"
                                                                required
                                                                noStyle
                                                            >
                                                                <SelectItem
                                                                    placeholder="Cuenta Ajuste Inventario"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Ingreso Contado" margin>
                                                        <Input.Group compact>
                                                            <FormItem
                                                                name="cuentaIngresoContadoId"
                                                                noStyle
                                                            >
                                                                <SelectItem
                                                                    placeholder="Cuenta Ingreso Contado"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Ingreso Credito" margin>
                                                        <Input.Group compact>
                                                            <FormItem
                                                                name="cuentaIngresoCreditoId"
                                                                noStyle
                                                            >
                                                                <SelectItem
                                                                    placeholder="Cuenta Ingreso Credito"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                    <FormItem label="Cuenta Poder de Terceros" margin>
                                                        <Input.Group compact>
                                                            <FormItem
                                                                name="cuentaTercerosId"
                                                                noStyle
                                                                required
                                                            >
                                                                <SelectItem
                                                                    placeholder="Cuenta Poder de Terceros"
                                                                    width="80%"
                                                                >
                                                                    {this.state.objetoCuentaContable}
                                                                </SelectItem>
                                                            </FormItem>
                                                            <ButtonItem
                                                                blanco
                                                                icon={<PlusOutlined />}
                                                                style={{ width: "20%" }}
                                                                onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                            />
                                                        </Input.Group>
                                                    </FormItem>
                                                </>
                                            );
                                        }
                                    }}
                                </FormItem>
                            </Col>
                            <Col span={6} ref={this.refCol2}>
                                <FormItem
                                    name="inventariable"
                                    valuePropName="checked"
                                    initialValue={true}
                                    specialLayoutSwitch
                                    label='Inventariable'
                                >
                                    <SwitchItem onChange={this.onChangeSwitches.bind(this)} />
                                </FormItem>
                                <FormItem
                                    name="transito"
                                    valuePropName="checked"
                                    initialValue={true}
                                    specialLayoutSwitch
                                    label='Transito'
                                >
                                    <SwitchItem onChange={this.onChangeSwitches.bind(this)} />
                                </FormItem>
                                <FormItem
                                    name="costo"
                                    valuePropName="checked"
                                    initialValue={true}
                                    specialLayoutSwitch
                                    label='Costo'
                                    tooltip={{ title: "Si se desactiva sería un gasto." }}
                                >
                                    <SwitchItem onChange={this.onChangeSwitches.bind(this)} />
                                </FormItem>
                                <FormItem
                                    name="ingresosSeparados"
                                    valuePropName="checked"
                                    initialValue={true}
                                    specialLayoutSwitch
                                    label='Separar Ingresos'
                                    tooltip={{ title: "Al estar activo se separan los ingresos por contado y credito." }}
                                >
                                    <SwitchItem onChange={this.onChangeSwitches.bind(this)} />
                                </FormItem>
                                <FormItem
                                    name="cuentaTercerosGenerar"
                                    valuePropName="checked"
                                    initialValue={true}
                                    specialLayoutSwitch
                                    label='Terceros'
                                    tooltip={{ title: "Al estar activo se crea una cuenta de inventario en poder de terceros." }}
                                >
                                    <SwitchItem onChange={this.onChangeSwitches.bind(this)} />
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </ModalItem>
                <AgregarCuentaContable
                    visible={this.state.modalAgregarCuentaContable}
                    cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
                        this
                    )}
                />
                <TourItem open={this.state.openTour} onClose={() => this.setState({ openTour: false })} steps={steps} />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarFamiliaConAsistente);
